import {Link as RouterLink} from 'react-router-dom';

import classnames from 'classnames';

import {colors} from 'shells/colors/colors';
import {ArrowRightThinIcon} from 'shells/icon/svg/arrow-right-thin-icon';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {NavigationItem} from './types';

import styles from './command-palette.module.css';

interface Props {
    item: NavigationItem;
    isActive: boolean;
    innerRef?: (el: HTMLDivElement | null) => void;
    onClick?: () => void;
}

export function SearchResultNavigation(props: Props) {
    const styleName = classnames(styles['result-row'], {
        [styles['result-row--active']]: props.isActive,
    });

    return (
        <div ref={props.innerRef}>
            <Link
                // @ts-expect-error
                as={RouterLink}
                to={props.item.path}
                className={styleName}
                onClick={props.onClick}
                data-result-id={props.item.id}
                preventUnderline={true}
            >
                <div className={styles['result-row-icon--navigation']}>
                    {/* @ts-expect-error */}
                    <ArrowRightThinIcon size={14} color={colors.blue} alignCenter={true} />
                </div>
                <div className='flex flex-dir-col flex-grow min-width-0'>
                    <Body size='normal' color='dark' truncate={{type: 'inline'}}>
                        {props.item.label}
                    </Body>
                    <Body size='small' color='light' truncate={{type: 'inline'}}>
                        {props.item.breadcrumb}
                    </Body>
                </div>
                <span className={styles['result-row-badge']}>Go to</span>
            </Link>
        </div>
    );
}
